import { ADD_VIDEO_OPTIONS } from "repoV2/pages/sale/constants";
import { ISalePageSectionsDataFromApi } from "./getSalePageTemplateDataApi.interfaces";

export const DEFAULT_SECTIONS_DATA: ISalePageSectionsDataFromApi = {
    aboutSection: {
        title: "",
        shortDescription: "",
        overline: "",
        progress: 0,
        sliderImgList: [],
    },
    guranteeSection: {
        title: "",
        shortDescription: "",
        imgSrc: "",
        description: "",
        sliderImgList: [],
    },
    bannerImage: {
        mediaType: "",
        videoSrc: "",
        imgSrc: "",
        title: "",
        hideControls: false,
        disableAutoPlay: false,
    },
    mainCtaButton: {
        ctaText: "",
    },
    MoneybackSection: {
        imgSrc: "",
        title: "",
    },
    DesiredOutcomesSection: {
        title: "",
        desiredOutcomesList: [],
        caption: "",
    },
    PainPointsSection: {
        title: "",
        CheckboxList: [],
    },
    stickyFooterSection: {
        title: "",
        description: "",
        showTimer: false,
        timerText: "",
    },
    ContactSection: {
        imgSrc: "",
        title: "",
        description: "",
    },
    requirementsSection: {
        title: "",
        requirementsList: [],
        description: "",
    },
    faqsSection: {
        title: "",
        faqsList: [],
    },
    contactCreatorSection: {
        title: "",
        description: "",
        getInTouchCtaText: "",
    },
    countdownTimer: {
        timerRunninngOutText: "",
        offerName: "",
        startTime: "",
        endTime: "",
        restartCounter: false,
    },
    bonusesSection: {
        title: "",
        bonusesList: [],
    },
    testimonialsSection: {
        title: "",
        testimonialsList: [],
    },
    highlightsSection: {
        title: "",
        highlightsList: [],
    },
    certificatesSection: {
        title: "",
        imgSrc: "",
        videoSrc: "",
        videoSrcType: ADD_VIDEO_OPTIONS.ADD_LINK.slug,
        mediaType: "",
        pointersList: [],
        description: "",
        hideControls: false,
        disableAutoPlay: true,
    },
    backgroundImage: {
        mediaType: "",
        videoSrc: "",
        imgSrc: "",
    },
    featuredInSection: {
        title: "",
        featuredInList: [],
    },
    howToParticipateSection: {
        title: "",
        howToParticipateList: [],
    },
    promotionalStatsSection: {
        userCount: {
            value: "",
            description: "",
        },
        rating: {
            value: "",
            description: "",
        },
    },
    whatYouWillDoSection: {
        title: "",
        description: "",
    },
    whoIsItForSection: {
        title: "",
        whoIsItForList: [],
    },
    whatYouWillLearn: {
        title: "",
        learnings: [],
    },
    contentCatalogueSection: {
        title: "",
        pointersList: [],
        catalogueItemsList: [],
    },
    demoVideoSection: {
        title: "",
        demoVideoSrc: "",
        demoVideoSrcType: ADD_VIDEO_OPTIONS.ADD_LINK.slug,
        disableAutoPlay: false,
        hideControls: false,
    },
    customPromoStatsSection: {
        title: "",
        customPromoStatsList: [],
    },
    aboutCreatorSection: {
        title: "",
        shortDescription: "",
        description: "",
        creatorImg: "",
        socialStatsList: [],
        sliderImgList: [],
    },
    circularBannerImageSection: {
        circularBannerImg: "",
    },
    multipleBackgroundImageSection: {
        bgImages: [],
    },
    coachIntroSection: {
        coachIntro: {
            title: "",
            description: "",
            imgSrc: "",
        },
        rating: {
            value: "",
            description: "",
        },
    },
    whatWillChangeInYourLife: {
        title: "",
        itemsList: [],
    },
    thisCouldBeYourLife: {
        title: "",
        lifeItemsList: [],
    },
    awards: {
        title: "",
        awardItemsList: [],
    },
    tabAssets: {
        title: "",
        favIcon: "",
    },
    heroSection: {
        title: "",
        description: "",
        logo: "",
    },
    actionHighlight: {
        ctaText: "",
    },
    customHighlights: {
        title: "",
        customHighlightsList: [],
    },
    callToAction: {
        title: "",
        description: "",
    },
    aboutBrandSection: {
        title: "",
        description: "",
        brandLogo: "",
    },
    gallerySection: {
        galleryVideoSrc: "",
        galleryVideoSrcType: ADD_VIDEO_OPTIONS.ADD_LINK.slug,
        galleryBannerImg: "",
        galleryImgList: [],
        disableAutoPlay: true,
        hideControls: false,
    },
    contentOutline: {
        title: "",
        description: "",
        contentOutlineList: [],
    },
    crossDataShowcase: {
        title: "",
        description: "",
        showcaseList: [],
    },
    demoVideoHighlights: {
        highlightsList: [],
    },
    stickyText: {
        title: "",
    },
};
